import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";
import axios from "axios";

export default function ChangePassword() {
  const { userId } = useSelector((state) => state.Auth);
    const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [ipAddress, setIP] = useState("");
  const [Password, setPassword] = useState("");
  const [Cpassword, setCpassword] = useState("");
  const [Ccpassword, setCcpassword] = useState("");

  const fetchIPAddress = async () => {
    try {
      const response = await axios.get("https://api64.ipify.org/?format=json");
      setIP(response.data.ip);
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address", error);
      toast.error("Unable to fetch IP address.");
      return null;
    }
  };

  const Updateprofilepassword = async () => {
    try {
      const ipaddress = await fetchIPAddress();
      if (!ipaddress) return;
      if (!Ccpassword) {
        toast.error("Please enter current password");
        return;
      } else if (!Password) {
        toast.error("Please enter new password");
        return;
      } else if (Password.length < 6) {
        toast.error(" Password must be at least 6 characters");
        return;
      } else if (Cpassword.length < 6) {
        toast.error("Confirm Password must be at least 6 characters");
        return;
      } else if (!Cpassword) {
        toast.error("Please enter confirm password");
        return;
      } else if (Password == Ccpassword) {
        toast.error("Old password can not be new password");
        return;
      } else if (Password != Cpassword) {
        toast.error("Password is not matched");
        return;
      }
      let res = await API.post(
        "/UpdateProfileAdmin",
        {
          loginid: userId,
          uid: userId,
          type: "password",
          password: Password,
          cpassword: Ccpassword,
          IP_address: ipaddress,
        },
        {
          headers: {
            Authorization: `${jwt_token}`,
          },
        }
      );
      if (res.data.data === "Current password is wrong!") {
        toast.error(`Current password is wrong!`);
        return;
      }
      if (res.data.data.Result === "Changes Password Update Successfully") {
        toast.success("Password Changed Successfully");
        setCcpassword("");
        setPassword("");
        setCpassword("");
        window.location.reload();
      } else {
        toast.error(`${res.data.data.Result}`);
      }
    } catch (e) {
      console.log("Error While calling userdetails API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        sessionStorage.clear();
        localStorage.clear();
        dispatch(
          updateAuth({
            AdminAuth: false,
            jwt_token: "",
            userId: null,
            username: null,
          })
        );
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Change Password</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <div className="d-flex justify-content-between">
                                  <h1>Current Password</h1>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>Current Password</label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Current Password"
                                    onChange={(e) => {
                                      setCcpassword(e.target.value);
                                    }}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>New Password</label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    placeholder="New Password"
                                    maxLength={20}
                                    onChange={(e) => {
                                      setPassword(e.target.value);
                                    }}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Confirm Password</label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    placeholder="New Password"
                                    maxLength={20}
                                    onChange={(e) => {
                                      setCpassword(e.target.value);
                                    }}
                                  />
                                </div>
                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={Updateprofilepassword}
                                  >
                                    Change Password
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
